import React from 'react';

export const getUnitPlcs = (unitData) => {
  if (Array.isArray(unitData?.plcs_arr) && unitData.plcs_arr.length > 0) {
    return unitData.plcs_arr;
  }
  return (unitData?.unitPlcs || [])
    .map((up) => ({
      id: up.plc?.id || up.plc_id,
      name: up.plc?.name,
      mode: up.plc?.mode,
      price: Number(up.plc?.price) || 0,
      gstInclusive: up.plc?.gstInclusive === true || up.plc?.gstInclusive === 'true',
      direction: up.direction
    }))
    .filter((plc) => plc.id);
};

export const PlcGstSelect = ({ plcs, gstByPlcId, onChange }) => {
  if (!Array.isArray(plcs) || plcs.length === 0) return null;

  return (
    <div className="col-span-2 flex flex-col gap-2">
      <label className="font-medium">PLC GST</label>
      <div className="flex flex-col gap-2 p-3 bg-gray-50 rounded border border-gray-200">
        {plcs.map((plc) => {
          const isInclusive = gstByPlcId?.[plc.id] === true;
          return (
            <div key={plc.id} className="flex flex-col gap-1.5">
              <span className="text-sm font-medium text-gray-800">
                {plc.name || 'PLC'}
                {unitDataPlcAmount(plc)}
              </span>
              <div className="flex flex-wrap gap-4 pl-1">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={isInclusive}
                    onChange={() => onChange(plc.id, true)}
                    className="h-4 w-4 accent-customBlue focus:ring-customBlue border-gray-300 rounded"
                  />
                  <span className="text-sm text-gray-700">Inclusive GST</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={!isInclusive}
                    onChange={() => onChange(plc.id, false)}
                    className="h-4 w-4 accent-customBlue focus:ring-customBlue border-gray-300 rounded"
                  />
                  <span className="text-sm text-gray-700">Exclusive GST</span>
                </label>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const unitDataPlcAmount = (plc) => {
  if (plc.mode === 'percent' && plc.price != null) {
    return ` — ${plc.price}%`;
  }
  return '';
};

export const toPlcGstModesPayload = (gstByPlcId) =>
  Object.entries(gstByPlcId || {}).map(([id, gstInclusive]) => ({
    id: Number(id),
    gstInclusive: gstInclusive === true
  }));
